<template>
  <div>
    <!-- 轮播图-->
    <carousel-page :type='5'></carousel-page>
    <!-- 企业介绍 Starts -->
    <section id='gqyjs' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>{{introduceInfo[0].title}}</h2>
              <p class='titleShadow'>{{introduceInfo[0].subTitle}}</p>
            </div>
          </div>
        </div>
        <div class="row flexJCenter" style='margin-top: -20px;'>
          <div class="col-lg-6">
            <div class="aboutCard mb-5">
             <p v-html='introduceInfo[0].content'></p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="aboutCard mb-5">
              <img style='width: 100%;' src="static/assets/images/about/js.png" alt="企业介绍">
            </div>
          </div>

        </div>
      </div>
    </section>
    <!-- 企业介绍 End -->
    <!-- 愿景与服务 Starts -->
    <section id='yjyfw' class="feature-area section-padding2">
      <img style='width: 100vw;z-index: -100;position: absolute;height: 580px;' src="static/assets/images/about/bg.png" alt="愿景与服务">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>愿景与服务</h2>
              <p class='titleShadow'>VISION AND SERVICE</p>
            </div>
          </div>
        </div>
        <div class="row flexJCenter">
          <div class="col-lg-5 textCenter">
            <div class="aboutCard mb-5">
              <img style='width: 80px;' src="static/assets/images/about/yj.png" alt="愿景">
              <h3>愿景</h3>
              <h4>VISION</h4>
              <p>成为中国涉旅行业最优数字化服务商</p>
              <p>成为智慧涉旅行业首选品牌</p>
            </div>
          </div>
          <div class="col-lg-5 textCenter">
            <div class="aboutCard mb-5">
              <img style='width: 80px;' src="static/assets/images/about/sm.png" alt="使命">
               <h3>使命</h3>
               <h4>MISSION</h4>
              <p>服务涉旅行业发展</p>
              <p>助力涉旅商家成功</p>
            </div>
          </div>

        </div>
      </div>
    </section>
    <!-- 愿景与服务 End -->
    <!-- Feature Area Starts -->
    <section id='wmnzsm' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>我们能做什么</h2>
              <p class='titleShadow'>WHAT CAN WE DO</p>
              <p>公司目前拥有数字化运营平台、营销云平台、分销云平台、数据指挥云平台、车辆监管平台、年卡运营平台、景区票务平台、政府监管平台等八大平台版块。依托于数字化平台为安阳市打造全域文旅智慧解决方案（安阳文旅公共服务中心），并集合本地资源推出相关产品线上数字化运营。</p>
            </div>
          </div>
        </div>
        <div class="row flexJCenter">
          <div class="col-lg-5 textCenter">
            <div class="single-feature mb-5">
              <h2>6年</h2>
              <h4>行业沉淀</h4>
              <p class="py-3">
                INDUSTRY PRECIPITATION</p>

            </div>
          </div>
          <div class="col-lg-5 textCenter">
            <div class="single-feature mb-5">
               <h2>7年</h2>
               <h4>运营经验</h4>
              <p class="py-3">
                OPERATIONAL EXPERIENCE</p>

            </div>
          </div>

        </div>
      </div>
    </section>
    <!-- Feature Area End -->
    <!-- CONTACT US Starts -->
    <section id='glxwm' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>联系我们</h2>
              <p class='titleShadow'>CONTACT US</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <img style='width: 100%;' src="static/assets/images/about/map.png" alt="联系我们">
          </div>


        </div>
      </div>
    </section>
    <!-- CONTACT US End -->
    <!-- 锚点-->
    <div class='SbgWarp'>
      <div class='bgtextTitle'>关于我们</div>
      <div class='fbgTextWarp'>
        <div @click='cutIndex(0)' :class='cutFbgTextIndex==0?"cutFbgTextItem":"fbgTextItem"'>企业介绍</div>
        <div @click='cutIndex(1)' :class='cutFbgTextIndex==1?"cutFbgTextItem":"fbgTextItem"'>愿景与服务</div>
        <div @click='cutIndex(2)' :class='cutFbgTextIndex==2?"cutFbgTextItem":"fbgTextItem"'>我们能做什么</div>
        <div @click='cutIndex(3)' :class='cutFbgTextIndex==3?"cutFbgTextItem":"fbgTextItem"'>联系我们</div>
      </div>
    </div>
  </div>
</template>

<script>
  import carouselPage from './module/carousel.vue'
  export default {
    components:{carouselPage},
    data(){
      return{
        introduceInfo:null,
        cutFbgTextIndex:0,
      }
    },
    mounted() {
      this.$http({
        method:'get',
        url:'http://123.57.1.182/website/api/website/article/list?type=企业介绍',
        data:{}
      }).then((res) => {
        console.log(res)
        if(res.data.code == 200){
          this.introduceInfo = res.data.data
        }
      })
    },
    methods:{
      cutIndex(index){
        this.cutFbgTextIndex = index
        if(index == 0){
          const gqyjs = document.getElementById("gqyjs");
          gqyjs.scrollIntoView({ behavior: "smooth" });
        }else if(index == 1){
          const yjyfw = document.getElementById("yjyfw");
          yjyfw.scrollIntoView({ behavior: "smooth" });
        }else if(index == 2){
          const wmnzsm = document.getElementById("wmnzsm");
          wmnzsm.scrollIntoView({ behavior: "smooth" });
        }else if(index == 3){
          const glxwm = document.getElementById("glxwm");
          glxwm.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
  }
</script>




// WEBPACK FOOTER //
// About.vue?777728c8